import { AvatarDropdown, AvatarName, Footer } from '@/components';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { history, Navigate, RunTimeLayoutConfig } from '@umijs/max';
import NoFoundPage from './pages/404';
import { jwtDecode } from "jwt-decode";
import defaultSettings from '../config/defaultSettings';
import { IUser } from './services/user.service';
import { Result, Button } from 'antd';

const loginPath = '/user/login';
const homepagePath = '/user/homepage';

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: IUser;
  loading?: boolean;
  fetchUserInfo?: () => any;
}> {
  const fetchUserInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        history.push(loginPath);
        return undefined;
      }
      const decodedToken: any = jwtDecode(token);
      const now = Date.now() / 1000;

      if (decodedToken?.exp < now) {
        localStorage.removeItem('token');
        history.push(loginPath);
        return undefined;
      }
      const userInfo = {
        role: decodedToken['claim.role']
      };
      return userInfo;
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  const publicPaths = ['/user/login', 'user/homepage'];
  const { location } = history;
  const isPublicRoute = publicPaths.includes(location.pathname);

  return {
    avatarProps: {
      title: <AvatarName />,
      render: (_, avatarChildren: any) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      if (!localStorage.getItem('token') && !isPublicRoute) {
        history.push(homepagePath);
      }
    },
    menuHeaderRender: undefined,
    childrenRender: (children: any) => {
      return children;
    },
    unAccessible: initialState?.currentUser ? (
      <Navigate to={new URL(window.location.href).searchParams.get('redirect') || '/'} />
    ) : (
      <Result
        status="403"
        title="403"
        subTitle="You are not authorized to access this page."
        extra={
          <Button type="primary" onClick={() => history.push('/')}>
            Back Home
          </Button>
        }
      />
    ),
    noFound: <NoFoundPage />,
    ...(isPublicRoute ? {} : initialState?.settings),
  };
};
